import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { ProvedorSessao, useSessao } from './sessao';
import { Entrar } from './paginas/Entrar';
import { Inicio } from './paginas/Inicio';
import { Moldura } from './componentes/Moldura';
import { ListaClientes } from './paginas/clientes/ListaClientes';
import { DetalheCliente } from './paginas/clientes/DetalheCliente';
import { ListaAtivos } from './paginas/ativos/ListaAtivos';
import { DetalheAtivo } from './paginas/ativos/DetalheAtivo';
import { ResolverEtiqueta } from './paginas/ativos/ResolverEtiqueta';
import { Agenda } from './paginas/agenda/Agenda';
import { ListaOs } from './paginas/os/ListaOs';
import { DetalheOs } from './paginas/os/DetalheOs';
import { Checklists } from './paginas/checklists/Checklists';
import { TarefasRapidas } from './paginas/checklists/TarefasRapidas';
import { Integracoes } from './paginas/integracoes/Integracoes';
import { Equipe } from './paginas/equipe/Equipe';
import { ListaContratos } from './paginas/contratos/ListaContratos';
import { DetalheContrato } from './paginas/contratos/DetalheContrato';
import { Documentos } from './paginas/contratos/Documentos';
import { RevisaoDocumento } from './paginas/contratos/RevisaoDocumento';
import { Preventivas } from './paginas/contratos/Preventivas';
import { DetalheUsuario } from './paginas/equipe/DetalheUsuario';
import { ListaChamados } from './paginas/chamados/ListaChamados';
import { DetalheChamado } from './paginas/chamados/DetalheChamado';
import { ListaOrcamentos } from './paginas/orcamentos/ListaOrcamentos';
import { DetalheOrcamento } from './paginas/orcamentos/DetalheOrcamento';
import { Despesas } from './paginas/despesas/Despesas';
import { TelaTrocarSenha } from './componentes/TrocarSenha';
const Mapa = lazy(() => import('./paginas/mapa/Mapa').then((m) => ({ default: m.Mapa })));
import './estilo.css';

function Protegido() {
  const { usuario, carregando } = useSessao();
  if (carregando) return <div className="carregando" aria-busy="true">Carregando…</div>;
  if (!usuario) return <Navigate to="/entrar" replace />;
  if (usuario.trocarSenha) return <TelaTrocarSenha />;   // senha provisória: o servidor também barra tudo até trocar
  return <Moldura />;
}

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <ProvedorSessao>
      <BrowserRouter>
        <Routes>
          <Route path="/entrar" element={<Entrar />} />
          <Route element={<Protegido />}>
            <Route index element={<Inicio />} />
            <Route path="agenda" element={<Agenda />} />
            <Route path="mapa" element={<Suspense fallback={<div className="carregando">Carregando mapa…</div>}><Mapa /></Suspense>} />
            <Route path="os" element={<ListaOs />} />
            <Route path="os/:id" element={<DetalheOs />} />
            <Route path="chamados" element={<ListaChamados />} />
            <Route path="chamados/:id" element={<DetalheChamado />} />
            <Route path="orcamentos" element={<ListaOrcamentos />} />
            <Route path="orcamentos/:id" element={<DetalheOrcamento />} />
            <Route path="despesas" element={<Despesas />} />
            <Route path="clientes" element={<ListaClientes />} />
            <Route path="clientes/:id" element={<DetalheCliente />} />
            <Route path="ativos" element={<ListaAtivos />} />
            <Route path="ativos/:id" element={<DetalheAtivo />} />
            <Route path="q/:codigo" element={<ResolverEtiqueta />} />
            <Route path="checklists" element={<Checklists />} />
            <Route path="checklists/tarefas" element={<TarefasRapidas />} />
            <Route path="integracoes" element={<Integracoes />} />
            <Route path="contratos" element={<ListaContratos />} />
            <Route path="contratos/documentos" element={<Documentos />} />
            <Route path="contratos/documentos/:id" element={<RevisaoDocumento />} />
            <Route path="contratos/:id" element={<DetalheContrato />} />
            <Route path="preventivas" element={<Preventivas />} />
            <Route path="equipe" element={<Equipe />} />
            <Route path="equipe/usuarios/:id" element={<DetalheUsuario />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ProvedorSessao>
  </StrictMode>,
);
